module.exports = __webpack_public_path__ + "static/media/litpass-logo.51c51beb.png";